<template>
  <div>
    <Nav />
    <el-form ref="ruleForm" class="addmemForm">
      <h3>团组成员不得低于{{minPersonNum}}人,已注册成员{{readyRegister}}人:</h3>
      <div v-if="personNum.length>0">
        <div class="group shadow" v-for="(item,index) in personNum" :key="index">
          <h3>同事*{{index+1}}</h3>
          <el-form-item>
            <span>
              称谓
              <b style="color:red">*</b>
            </span>
            <el-radio
              label="先生"
              v-model="personNum[index][index+1].psngender"
              :checked="personNum[index][index+1].psngender=='先生'"
              name="psngender"
            >先生</el-radio>
            <el-radio
              label="女士"
              v-model="personNum[index][index+1].psngender"
              :checked="personNum[index][index+1].psngender=='女士'"
            >女士</el-radio>
          </el-form-item>
          <div class="box flex-wrap">
            <el-form-item class="item">
              <span>
                姓名
                <b style="color:red">*</b>
              </span>
              <el-input
                placeholder="请输入您的姓名"
                v-model="personNum[index][index+1].psnname"
                @blur.stop="regInput('psnname',index)"
                name="psnname"
              ></el-input>
            </el-form-item>
            <el-form-item class="item">
              <span>
                职位
                <b style="color:red">*</b>
              </span>
              <el-input
                placeholder="请输入您的职务"
                v-model="personNum[index][index+1].psnrank"
                @blur.stop="regInput('psnrank',index)"
                name="psnrank"
              ></el-input>
            </el-form-item>
            <el-form-item class="item">
              <span>
                手机号
                <b style="color:red">*</b>
              </span>
              <el-input
                placeholder="请输入您的手机号"
                maxlength="11"
                v-model="personNum[index][index+1].psnmobile"
                @keyup.native="onlyNum('psnmobile',index)"
                @blur.stop="regInput('psnmobile',index)"
                name="iphone"
              ></el-input>
            </el-form-item>
            <el-form-item class="item">
              <span>
                邮箱
                <b style="color:red">*</b>
              </span>
              <el-input
                placeholder="请输入您的邮箱"
                v-model="personNum[index][index+1].psnemail"
                @blur.stop="regInput('psnemail',index)"
                name="email"
              ></el-input>
            </el-form-item>
            <el-form-item class="item">
              <span>
                身份证号
                <b style="color:red">*</b>
              </span>
              <el-input
                placeholder="请输入您的身份证号"
                v-model="personNum[index][index+1].psnidcard"
                @blur.stop="regInput('psnidcard',index)"
                name="idcard"
              ></el-input>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="btn-wrap">
        <el-button type="primary" :style="btnAllStyle" @click="goBackaddMember">查看成员信息</el-button>
        <el-button type="primary" :style="btnAllStyle" @click="addOne">新增成员</el-button>
        <el-button type="primary" :style="btnAllStyle" @click="saveInfo">提交信息</el-button>
        <el-button type="primary" :style="btnAllStyle" @click="del" v-if="isShowDelBtn">删除</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import _ from 'lodash'
import api from '../api'
import regExp from '../utils/regExp.js'
import utils from '../utils'
import Nav from '../components/Nav'
export default {
  name: 'AddMember',
  components: {
    Nav
  },
  data() {
    return {
      btnAllStyle: sessionStorage.getItem('btnAll') ? JSON.parse(sessionStorage.getItem('btnAll')).styles : {},
      ExhID: sessionStorage.getItem('ExhID'),
      personNum: [],
      minPersonNum: parseInt(sessionStorage.getItem('GroupListNumber')) || 0,
      personInfoBtn: true,
      sex: '先生',
      readyRegister: parseInt(sessionStorage.getItem('groupInfoLength')),
      repeatMobile: [],
      repeatEmail: [],
      isPhoneCheckArr: [], // 手机查重结果数组
      isEmailCheckArr: [], // 邮箱查重结果数组
      isIDCardCheckArr: [], // 身份证号结果数组
      isShowDelBtn: false, // 是否显示删除del按钮
      realNum: 0
    }
  },
  mounted() {
    this.init()
    utils.setThemeColor()
  },
  methods: {
    del: function() {
      this.personNum.pop()
    },
    phoneCheck: function(index, val) {
      var obj = { iphone: val }
      if (obj.iphone && !regExp.regCheckCnMobile.test(obj.iphone)) {
        // this.$alert('手机号格式错误，请重新输入')
        // document.getElementsByName('PsnMobile')[0].focus();
      } else if (regExp.regCheckCnMobile.test(obj.iphone)) {
        var param = {
          exhid: this.ExhID,
          PsnMobile: obj.iphone
        }
        api.mobileRepeat(param).then(res => {
          if (res.data.status === 'OK') {
            this.isPhoneCheckArr[index] = true
          } else {
            this.$alert(
              '同事*' + (index + 1) + '的手机号已在本届展会注册过！',
              {
                callback: function() {
                  document.getElementsByName('iphone')[index].focus()
                }
              }
            )
            this.isPhoneCheckArr[index] = false
          }
        })
      } else if (regExp.notEmpty.test(obj.iphone)) {
      }
    },
    emailCheck(index, val) {
      var obj = { email: val }
      if (obj.email && regExp.regCheckEmail.test(obj.email)) {
        var param = {
          exhid: this.ExhID,
          PsnEmail: obj.email
        }
        api.emailRepeat(param).then(res => {
          if (res.data.status === 'OK') {
            this.isEmailCheckArr[index] = true
          } else {
            this.$alert('同事*' + (index + 1) + '的邮箱已在本届展会注册过！', {
              callback: function() {
                document.getElementsByName('email')[index].focus()
              }
            })
            this.isEmailCheckArr[index] = false
          }
        })
      } else if (regExp.notEmpty.test(obj.email)) {
        // this.isEmailCheck=true;
      }
    },
    idCardCheck(index, val) {
      api.IDCardRepeat({
        exhid: this.ExhID,
        PsnIDCard: val
      }).then(res => {
        if (res.data.status === 'OK') {
          this.isIDCardCheckArr[index] = true
        } else {
          this.$alert('同事*' + (index + 1) + '的身份证号已在本届展会注册过！', {
            callback: function() {
              document.getElementsByName('idcard')[index].focus()
            }
          })
          this.isIDCardCheckArr[index] = false
        }
      })
    },
    saveInfo: _.throttle(function() {
      // 提交团组注册 函数;
      var arr = this.personNum
      for (var i = 0; i < arr.length; i++) {
        var index = i
        var obj0 = arr[index]
        var obj1 = obj0[index + 1]

        if (!obj1.psngender) {
          this.$alert('请选择同事*' + (i + 1) + '的称谓')
          document.getElementsByName('psngender')[i].focus()
          return ''
        } else if (!obj1.psnname) {
          this.$alert('请填写同事*' + (i + 1) + '的姓名')
          document.getElementsByName('psnname')[i].focus()
          return ''
        } else if (obj1.psnname.length < 2) {
          this.$alert('同事*' + (i + 1) + '的姓名长度不能小于2位')
          document.getElementsByName('psnname')[i].focus()
          return ''
        } else if (!this.submitReg('psnname', obj1.psnname)) {
          this.$alert('同事*' + (i + 1) + '的姓名格式错误,请重新输入')
          document.getElementsByName('psnname')[i].focus()
          return ''
        } else if (!obj1.psnrank) {
          this.$alert('请输入同事*' + (i + 1) + '的职务')
          document.getElementsByName('psnrank')[i].focus()
          return ''
        } else if (obj1.psnrank.length < 2) {
          this.$alert('同事*' + (i + 1) + '的职务长度不能小于2位')
          document.getElementsByName('psnrank')[i].focus()
          return ''
        } else if (!this.submitReg('psnrank', obj1.psnrank)) {
          this.$alert('同事*' + (i + 1) + '的职务格式错误,请重新输入')
          document.getElementsByName('psnrank')[i].focus()
          return ''
        } else if (!obj1.psnmobile) {
          this.$alert('请输入同事*' + (i + 1) + '的手机号')
          document.getElementsByName('iphone')[i].focus()
          return ''
        } else if (!this.submitReg('psnmobile', obj1.psnmobile)) {
          this.$alert('同事*' + (i + 1) + '的手机号格式错误,请重新输入')
          document.getElementsByName('iphone')[i].focus()
          return ''
        } else if (!obj1.psnemail) {
          this.$alert('请输入同事*' + (i + 1) + '的邮箱')
          document.getElementsByName('email')[i].focus()
          return ''
        } else if (!this.submitReg('psnemail', obj1.psnemail)) {
          this.$alert('同事*' + (i + 1) + '的邮箱格式错误,请重新输入')
          document.getElementsByName('email')[i].focus()
          return ''
        } else if (!obj1.psnidcard) {
          this.$alert('请输入同事*' + (i + 1) + '的身份证号')
          document.getElementsByName('idcard')[i].focus()
          return ''
        } else if (!utils.regCId(obj1.psnidcard)) {
          this.$alert('同事*' + (i + 1) + '的身份证号错误,请重新输入')
          document.getElementsByName('idcard')[i].focus()
          return ''
        } else {
          for (var j = i + 1; j < arr.length; j++) {
            var obj = arr[j][j + 1]
            if (obj1.psnmobile === obj.psnmobile) {
              this.$alert(
                '同事*' + (i + 1) + '、同事*' + (j + 1) + '的手机号相同'
              )
              document.getElementsByName('iphone')[i].focus()
              return ''
            } else if (obj1.psnemail === obj.psnemail) {
              this.$alert(
                '同事*' + (i + 1) + '、同事*' + (j + 1) + '的邮箱相同'
              )
              document.getElementsByName('email')[i].focus()
              return ''
            } else if (obj1.psnidcard === obj.psnidcard) {
              this.$alert(
                '同事*' + (i + 1) + '、同事*' + (j + 1) + '的身份证号相同'
              )
              document.getElementsByName('idcard')[i].focus()
              return ''
            }
          }
          if (
            !this.isPhoneCheckArr[i] &&
            typeof this.isPhoneCheckArr[i] !== 'undefined'
          ) {
            this.$alert('同事*' + (index + 1) + '的手机号已在本届展会注册过！')
            return ''
          } else if (
            !this.isEmailCheckArr[i] &&
            typeof this.isEmailCheckArr[i] !== 'undefined'
          ) {
            this.$alert('同事*' + (index + 1) + '的邮箱已在本届展会注册过！')
            return ''
          } else if (
            !this.isIDCardCheckArr[i] &&
            typeof this.isIDCardCheckArr[i] !== 'undefined'
          ) {
            this.$alert('同事*' + (index + 1) + '的身份证号已在本届展会注册过！')
            return ''
          }
        }
      }
      // 递归实名验证
      if (sessionStorage.getItem('isConsistencyIdCard') && sessionStorage.getItem('isConsistencyIdCard') === 'true') {
        // 如果开启实名验证
        this.realNameID()
        // this.submitGroupInfo()
      } else {
        // 直接提交
        this.submitGroupInfo()
      }
    }, 1000),
    submitGroupInfo() {
      var GroupData = []
      for (let j = 0; j < this.personNum.length; j++) {
        GroupData.push(this.personNum[j][j + 1])
      }
      GroupData = JSON.stringify(GroupData)
      console.log(GroupData, 'gggg')
      var groupInfo = {
        exhid: this.ExhID,
        PsnID: sessionStorage.getItem('PsnID'),
        Language: 'cn',
        GroupData: GroupData
      }
      // 提交团组注册
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      api.groupRegist(groupInfo).then(res => {
        loading.close()
        if (res.data.status === 'OK') {
          this.readyRegister =
            Number(this.personNum.length) + Number(this.readyRegister)
          this.personNum = []
          this.personNum.push({
            '1': {
              psngender: '',
              psnname: '',
              psnrank: '',
              psnmobile: '',
              psnemail: '',
              psnidcard: ''
            }
          })
          this.$alert('注册成功')
        } else {
          this.$alert(res.data.ErrorMsg)
        }
      })
    },
    realNameID() {
      if(this.realNum < this.personNum.length) {
        utils.realNameVerification(this, this.personNum[this.realNum][this.realNum + 1].psnname, this.personNum[this.realNum][this.realNum + 1].psnidcard).then(realRes => {
          if(realRes === 'true') {
            this.realNum++
            this.realNameID()
          } else {
            this.$alert('同事' + (this.realNum + 1) + '的姓名与身份证号不符！', '错误信息', {
              confirmButtonText: '确定',
              closeOnClickModal: true,
              type: 'error'
            });
            this.loading = false
          }
        })
      } else{
        this.submitGroupInfo()
      }
    },
    change: function(key, index, v) {
      var obj = this.personNum
      var ev = event || window.event
      var target = ev.target || ev.srcElement

      var val
      if (key === 'psngender') {
        val = v
      } else {
        val = target.value
      }
      val = val.trim()
      obj[index][index + 1][key] = val
      this.personNum = obj
      target.value = val
    },
    clearSpace: function(key, index) {
      var obj = this.personNum
      var val = obj[index][index + 1][key]
      obj[index][index + 1][key] = val.trim()
      this.personNum = val
    },
    onlyNum: function(key, index) {
      var obj = this.personNum
      var val = obj[index][index + 1][key]

      obj[index][index + 1][key] = val.replace(/\D/g, '')
      this.personNum = obj
    },
    regInput: function(types, index, val) {
      var ev = event || window.event
      var target = ev.target || ev.srcElement
      var obj = this.personNum

      if (!val) {
        val = target.value
      }
      this.clearSpace(types, index)
      if (types === 'psnname') {
        if (
          regExp.regCheckCnName.test(val) ||
          regExp.regCheckEnName.test(val)
        ) {
          obj[index][index + 1]['psnnameerr'] = ''
        } else {
          obj[index][index + 1]['psnnameerr'] = '请输入正确的姓名'
          this.personNum = obj

          return false
        }
      } else if (types === 'psnmobile') {
        if (regExp.regCheckCnMobile.test(val)) {
          obj[index][index + 1]['psnmobileerr'] = ''
          this.isPhoneCheckArr[index] = true
          this.phoneCheck(index, val)
        } else {
          obj[index][index + 1]['psnmobileerr'] = '请输入正确的手机号'
          this.personNum = obj

          return false
        }
      } else if (types === 'psnemail') {
        if (regExp.regCheckEmail.test(val)) {
          obj[index][index + 1]['psnemailerr'] = ''
          this.isEmailCheckArr[index] = true
          this.emailCheck(index, val)
        } else {
          obj[index][index + 1]['psnemailerr'] = '请输入正确的邮箱'
          this.personNum = obj
          return false
        }
      } else if (types === 'psnidcard') {
        if (utils.regCId(val)) {
          obj[index][index + 1]['psnidcarderr'] = ''
          this.isIDCardCheckArr[index] = true
          // 身份证号实名验证， 查重
          this.idCardCheck(index, val)
        } else {
          obj[index][index + 1]['psnidcarderr'] = '请输入正确的身份证号'
          this.personNum = obj
          return false
        }
      } else if (types === 'psngender') {
      } else if (types === 'psnrank') {
        if (!regExp.regCheckRank.test(val)) {
          obj[index][index + 1]['psnrankerr'] = '请输入正确的职务'
          this.personNum = obj
          return false
        } else {
          obj[index][index + 1]['psnrankerr'] = ''
        }
      }
      this.personNum = obj
    },
    submitReg(types, val) {
      if (val && types === 'psnname') {
        if (!regExp.regCheckCnName.test(val) && !regExp.regCheckEnName.test(val)) {
          return false
        }
      } else if (val && types === 'psnmobile') {
        if (!regExp.regCheckCnMobile.test(val)) {
          return false
        }
      } else if (val && types === 'psnemail') {
        if (!regExp.regCheckEmail.test(val)) {
          return false
        }
      } else if (val && types === 'psnidcard') {
        if (!utils.regCId.test(val)) {
          return false
        }
      } else if (val && types === 'psnrank') {
        if (!regExp.regCheckRank.test(val)) {
          return false
        }
      } else {
        return false
      }
      return true
    },
    addOne: function() {
      var obj = {}
      obj[this.personNum.length + 1 + ''] = {
        psngender: '',
        psnname: '',
        psnrank: '',
        psnmobile: '',
        psnemail: '',
        psnidcard: '',
        psnnameerr: '',
        psnrankerr: '',
        psnmobileerr: '',
        psnemailerr: '',
        psnidcarderr: ''
      }

      this.personNum.push(obj)
    },

    goBackaddMember: function() {
      this.$router.push('groupRegister')
    },
    init() {
      if (this.minPersonNum) {
        // 如果设置了下限
        if (this.readyRegister >= this.minPersonNum) {
          this.personNum.push({
            '1': {
              psngender: '',
              psnname: '',
              psnrank: '',
              psnmobile: '',
              psnemail: '',
              psnidcard: '',
              psnnameerr: '',
              psnrankerr: '',
              psnmobileerr: '',
              psnemailerr: '',
              psnidcarderr: ''
            }
          })
          return
        }
      }
      // 需要渲染的列表数
      var tableLength = this.minPersonNum - this.readyRegister
      for (var k = 0; k < tableLength; k++) {
        var obj = {}
        obj[k + 1 + ''] = {
          psngender: '',
          psnname: '',
          psnrank: '',
          psnmobile: '',
          psnemail: '',
          psnidcard: '',
          psnnameerr: '',
          psnrankerr: '',
          psnmobileerr: '',
          psnemailerr: '',
          psnidcarderr: ''
        }

        this.personNum.push(obj)
      }
    }
    // getPageConfig: function() {
    //   var param = {
    //     ExhID: this.ExhID,
    //     RegistType: 'pc',
    //     page: 'GroupList'
    //   }
    //   var loading = this.$loading({
    //     lock: true,
    //     text: 'Loading',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(0, 0, 0, 0.7)'
    //   })

    //   api.getPage(param).then(res => {
    //     loading.close()
    //     if (res.data.status === 'OK') {
    //       for (var i = 0; i < res.data.promptinfo.length; i++) {
    //         if (res.data.promptinfo[i].name === 'GroupListNumber') {
    // GroupListNumber 最小注册量
    //           this.minPersonNum = res.data.promptinfo[i].value
    //           if (
    //             Number(this.readyRegister) >=
    //             Number(res.data.promptinfo[i].value)
    //           ) {
    //             this.personNum.push({
    //               '1': {
    //                 psngender: '',
    //                 psnname: '',
    //                 psnrank: '',
    //                 psnmobile: '',
    //                 psnemail: '',
    //                 psnidcard: '',
    //                 psnnameerr: '',
    //                 psnrankerr: '',
    //                 psnmobileerr: '',
    //                 psnemailerr: '',
    //                 psnidcarderr: ''
    //               }
    //             })
    //             return
    //           }
    //           // 需要渲染的列表数
    //           var tableLength = res.data.promptinfo[i].value - this.readyRegister
    //           for (var k = 0; k < tableLength; k++) {
    //             var obj = {}
    //             obj[k + 1 + ''] = {
    //               psngender: '',
    //               psnname: '',
    //               psnrank: '',
    //               psnmobile: '',
    //               psnemail: '',
    //               psnidcard: '',
    //               psnnameerr: '',
    //               psnrankerr: '',
    //               psnmobileerr: '',
    //               psnemailerr: '',
    //               psnidcarderr: ''
    //             }

    //             this.personNum.push(obj)
    //           }
    //         }
    //       }
    //     } else {
    //       this.$alert(res.data.ErrorMsg)
    //     }
    //   })
    // }
  }
}
</script>
<style scoped>
.flex-wrap {
  display: flex;
  justify-content: space-between;
  flex-flow: wrap;
}
.addmemForm{
  background:#fff;
}
.addmemForm>h3{
  padding: 20px 56px;
  border-bottom:1px solid #eee;
}
.group {
  box-sizing: border-box;
  padding: 15px 66px;
}
.group:last-of-type {
  margin-bottom: 0;
}
#addMember_box {
  width: 100%;
  min-width: 100%;
  box-sizing: border-box;
  padding: 15px;
  background: #fff;
}
.addGroupInfoTop {
  margin-bottom: 15px;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
}
.box .item {
  width: 100%;
  max-width: 400px;
}
.btn-wrap {
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding: 15px 5px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  max-width: 980px;
  margin:0 auto;
}

</style>



// WEBPACK FOOTER //
// src/pages/AddMember.vue